/* ============================================================
   Maison Atelier Premium — wishlist.js
   Wishlist front-end via localStorage (nessun account richiesto)
   ============================================================ */
(function () {
  'use strict';
  var strings = (window.theme && window.theme.strings) || {};

  var Wishlist = {
    key: 'sav_wishlist',
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    set: function (list) { localStorage.setItem(this.key, JSON.stringify(list)); },
    has: function (handle) { return this.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var list = this.get();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle); else list.splice(idx, 1);
      this.set(list);
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length, handle: handle, added: idx === -1 } }));
      return idx === -1;
    },
    syncButtons: function (root) {
      var self = this;
      (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var active = self.has(btn.getAttribute('data-wishlist-toggle'));
        btn.setAttribute('aria-pressed', String(active));
        btn.setAttribute('aria-label', active ? (strings.wishlistRemove || '') : (strings.wishlistAdd || ''));
      });
    }
  };
  window.theme = window.theme || {};
  window.theme.Wishlist = Wishlist;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var active = Wishlist.toggle(btn.getAttribute('data-wishlist-toggle'));
    btn.setAttribute('aria-pressed', String(active));
    btn.setAttribute('aria-label', active ? (strings.wishlistRemove || '') : (strings.wishlistAdd || ''));
  });

  function updateCount() {
    var n = Wishlist.get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  document.addEventListener('wishlist:updated', updateCount);
  document.addEventListener('cards:rendered', function (e) {
    Wishlist.syncButtons(e.detail && e.detail.root ? e.detail.root : document);
  });

  Wishlist.syncButtons();
  updateCount();
})();
